import { render, staticRenderFns } from "./DpvLotsModal.vue?vue&type=template&id=4156e616&scoped=true"
import script from "./DpvLotsModal.vue?vue&type=script&lang=js"
export * from "./DpvLotsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4156e616",
  null
  
)

export default component.exports